module.exports = __webpack_public_path__ + "static/media/reward-center-icon-glow.18cf28bb.png";